import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { getTitlePrefix } from '../config/env';
import { StaffMain } from '../documents';

import { MainContentLayout } from '@wonderschool/common-base-ui';

const FormsAndDocuments: React.FC = () => {
  const { t } = useTranslation();

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('pages.documents.browserTitle')}
      </title>
      <body />
    </Helmet>
  );

  return (
    <MainContentLayout title={t('Documents')}>
      {renderPageHead()}
      <StaffMain />
    </MainContentLayout>
  );
};

export default FormsAndDocuments;
